
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <p>{`This project was developed to provide `}<strong parentName="p">{`ICON`}</strong>{` components for `}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://www.univer.ai"
        }}>{`Univer`}</a></strong>{`.`}</p>
    <h2>{`Icon`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/yuhongz/univer-icons"
      }}>{`https://github.com/yuhongz/univer-icons`}</a></p>
    <h2>{`Univer`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/dream-num/univer"
      }}>{`https://github.com/dream-num/univer`}</a></p>
    <h2>{`Contact Us`}</h2>
    <p><a parentName="p" {...{
        "href": "mailto:zhangyuhong@univer.ai"
      }}>{`zhangyuhong@univer.ai`}</a></p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;